import BackendService from "@/services/BackendService";

export const namespaced = true;

export const state = {
  currentOffer: 0,
  offers: [],
  currentMyOffer: 0,
  myOffers: []
};

export const mutations = {
  SET_OFFERS(state, offers) {
    state.offers = offers;
  },
  DELETE_OFFER(state, offerId) {
    const index = state.offers.findIndex(offer => offer.id === offerId);
    state.offers.splice(index, 1);
    state.currentOffer = index > 0 ? index - 1 : 0;
    console.log("reset current to ", index > 0 ? index - 1 : 0);
  },
  SET_CURRENT_OFFER(state, value) {
    if (value === undefined) {
      value = 0;
    }
    console.log("set current to ", value);
    state.currentOffer = value;
  },
  SET_MY_OFFERS(state, offers) {
    state.myOffers = offers;
    console.log("reset current to 0");
    state.currentMyOffer = 0;
  },
  DELETE_MY_OFFER(state, offerId) {
    const index = state.myOffers.findIndex(offer => offer.id === offerId);
    state.myOffers.splice(index, 1);
    state.currentMyOffer = index > 0 ? index - 1 : 0;
  },
  SET_CURRENT_MY_OFFER(state, value) {
    if (value === undefined) {
      value = 0;
    }
    console.log("set current to ", value);
    state.currentMyOffer = value;
  }
};
export const actions = {
  async fetch({ state, commit, dispatch }, reset = false) {
    if (reset) {
      await dispatch("reset");
    }
    // if (state.offers.length === 0) {
    return BackendService.getOffers()
      .then(({ data }) => {
        commit("SET_OFFERS", data);
      })
      .catch(error => {
        console.log("Error fetching offers", error);
        throw error;
      });
    // }
  },
  fetchMine({ commit }) {
    return BackendService.getMyOffers()
      .then(({ data }) => {
        commit("SET_MY_OFFERS", data);
      })
      .catch(error => {
        console.log("Error fetching offers", error);
        throw error;
      });
  },
  reset({ state }) {
    state.offers = [];
  },
  postReaction({ commit, dispatch }, reaction) {
    console.log("action postReaction with", reaction);
    BackendService.postReaction(reaction)
      .then(() => {
        return dispatch("fetch");
      })
      .catch(error => {
        console.log("Error fetching offers", error);
        throw error;
      });
  },
  confirm({ commit }, reaction) {
    return BackendService.confirmReaction(reaction.id);
  },
  cancelOffer({ commit, dispatch }, id) {
    return BackendService.cancelOffer(id)
      .then(() => {
        return dispatch("fetchMine");
      })
      .catch(error => {
        console.log("Error cancelling offer", error);
        throw error;
      });
  }
};

export const getters = {
  getOfferCount: state => {
    return state.offers.length;
  },
  getMyOfferCount: state => {
    return state.myOffers.length;
  },
  getOffer: state => id => {
    return state.offers.find(offer => offer.id === id);
  },
  getMyOffer: state => index => {
    return state.myOffers[index];
  },
  getReactions: state => index => {
    return state.myOffers[index].reactions;
  },
  getReactionsByAvailability: state => (index, isAvailable) => {
    isAvailable = isAvailable ? 1 : 0;
    let reactions = state.myOffers[index].reactions;
    return reactions.filter(reaction => {
      return reaction.is_available === isAvailable;
    });
  }
};
